import {StrapiAuthApi} from "services/strapi";
import {IUser} from "features/users";

class AuthApi extends StrapiAuthApi<IUser> {

}

export const authApi = new AuthApi();
